import { render, staticRenderFns } from "./DemoRegisterModal.vue?vue&type=template&id=6afc4618&scoped=true"
import script from "./DemoRegisterModal.vue?vue&type=script&lang=js"
export * from "./DemoRegisterModal.vue?vue&type=script&lang=js"
import style0 from "./DemoRegisterModal.vue?vue&type=style&index=0&id=6afc4618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc4618",
  null
  
)

export default component.exports